var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"feature-item"},[_c('div',{staticClass:"feature-title"},[_vm._t("title")],2),_c('div',{staticClass:"feature-content"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }